var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-grid');
import { breakpoints, theme } from '@shapeable/theme';
import { entityPluralLabel } from '../../utils/entity-plural-label';
import { Grid } from '../elements/grid';
import { toArray } from '../../utils/to-array';
import { mapValues, pickBy, map, uniqBy, get, size, find, flatten, sortBy, filter, intersection } from 'lodash';
import { EntityCard } from '../entities/entity-card';
import { EntitySelect } from '../entities/entity-select';
import { Card } from '../elements/card';
import { EntityFilterSelectReplaceable } from './entity-filter-select';
import { titleCase } from '../../utils/title-case';
export var EntityGridDefaultProps = {
  items: [],
  filterFieldNames: [],
  filterValues: {},
  filterFieldOptions: {},
  card: EntityCard,
  select: EntitySelect,
  onFilterValuesChange: function onFilterValuesChange() {},
  desktopAutoColumns: 3,
  tabletAutoColumns: 2
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var CardStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FiltersStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    margin-top: ", ";\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var FilterStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    min-height: 68px;\n  "], ["\n    min-height: 68px;\n  "]))),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FilterSelectStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});

var ids = function ids(items) {
  if (items === void 0) {
    items = [];
  }

  return items.map(function (item) {
    return item.id || item.value;
  });
}; // -------- Components -------->


var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Filters: styled(Grid)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FiltersStyles),
  Filter: styled.div.attrs(cls.attr('filter'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), FilterStyles),
  FilterSelect: styled(EntityFilterSelectReplaceable)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FilterSelectStyles),
  Grid: styled(Grid)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Card: styled(Card)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), CardStyles)
};
export var EntityGrid = function EntityGrid(props) {
  var className = props.className,
      filterValues = props.filterValues,
      items = props.items,
      filterFieldNames = props.filterFieldNames,
      onFilterValuesChange = props.onFilterValuesChange,
      cardMaxWords = props.cardMaxWords,
      gridProps = __rest(props, ["className", "filterValues", "items", "filterFieldNames", "onFilterValuesChange", "cardMaxWords"]);

  var allItems = props.items;
  var hasFilters = !!filterFieldNames.length;
  var filterItems = useMemo(function () {
    return pickBy(filterFieldNames.reduce(function (acc, fieldName) {
      acc[fieldName] = sortBy(uniqBy(flatten(allItems.map(function (item) {
        return item[fieldName] || [];
      })), 'id'), 'name');
      return acc;
    }, {}), function (filterItem) {
      return filterItem && filterItem.length;
    });
  }, [items]); // console.log(filterItems);

  var filterFieldOptions = __assign(__assign({}, props.filterFieldOptions), mapValues(filterItems, function (filterItem, key) {
    var knownEntityTypeName = filterItem.length && filterItem[0].__typename;
    var entityTypeName = knownEntityTypeName || 'Entity';
    var placeholder = knownEntityTypeName ? entityPluralLabel(filterItem.length && filterItem[0]) : titleCase(key);
    return {
      placeholder: placeholder,
      entityTypeName: entityTypeName
    };
  })); // console.log(filterFieldOptions);


  var filterValueIds = mapValues(filterValues, function (item) {
    return ids(item || []);
  });
  var matchingItems = hasFilters ? filter(allItems, function (item) {
    return size(filterValues) === 0 || find(filterValueIds, function (idSet, fieldName) {
      return !!intersection(ids(toArray(item[fieldName])), idSet).length;
    });
  }) : allItems;

  var onSelectChange = function onSelectChange(fieldName) {
    return function (value) {
      var _a;

      var newValue = __spreadArray([], __read(value || []), false);

      var newFilters = pickBy(__assign(__assign({}, filterValues), (_a = {}, _a[fieldName] = !!newValue.length && newValue, _a)));
      onFilterValuesChange(newFilters);
    };
  };

  var Card = props.card;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasFilters && React.createElement(My.Filters, {
    maxColumns: size(filterItems),
    spacing: 0,
    items: map(filterItems, function (filterItem, fieldName) {
      return React.createElement(My.Filter, {
        key: "filter-" + fieldName
      }, React.createElement(My.FilterSelect, {
        isMulti: true,
        value: filterValues[fieldName] || [],
        onChange: onSelectChange(fieldName),
        placeholder: get(filterFieldOptions, fieldName + ".placeholder", 'Select'),
        entityTypeName: get(filterFieldOptions, fieldName + ".placeholder", 'Entity'),
        items: filterItem
      }));
    })
  }), React.createElement(My.Grid, __assign({}, gridProps, {
    items: matchingItems.map(function (item) {
      return React.createElement(Card, {
        key: item.id,
        maxWords: cardMaxWords,
        entity: item
      });
    })
  })));
};
EntityGrid.defaultProps = EntityGridDefaultProps;
EntityGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;